var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 72,
    viewBox: "0 0 54 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 39.7256V32.2773H24.5454V39.7256H17.1818V42.2084H24.5454V49.6566H27V42.2084H34.3636V39.7256H27ZM42.9509 1.67962e-05H3.69041C2.71309 -0.00295106 1.77477 0.387499 1.08243 1.08523C0.390097 1.78296 0.000647577 2.73064 0 3.71919V68.2808C0.00676361 70.3373 1.65723 72.0007 3.69041 72H50.3096C51.2869 72.003 52.2252 71.6125 52.9176 70.9148C53.6099 70.217 53.9994 69.2694 54 68.2808V11.1699V18.6207L35.5909 1.67962e-05H42.9509ZM35.5909 6.20702L47.8636 18.6208H36.812C36.137 18.6208 35.5909 18.0547 35.5909 17.3856V6.20702Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFile);
export default __webpack_public_path__ + "static/media/selectFile.72a8368abfc78d67191e52990faef42c.svg";
export { ForwardRef as ReactComponent };